import {JetView} from "webix-jet"; // Importing JetView from webix-jet framework
import {devConfig, countries, profile, walletsList} from "../../../config/config"; // Importing configuration settings

/**
 * Class representing the FilterJackpotPrizeReportCasinoView.
 * @extends JetView
 */
export default class FilterJackpotPrizeReportCasinoView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService("locale")._; // Localization service for translations
        const left = {
            id: "a1",
            margin: 5,
            rows: [
                {
                    responsive: "a1",
                    margin: 15,
                    css: "on-row",
                    cols: [
                        {
                            id: 'Datepicker', // Date range picker ID
                            name: "Datepicker",
                            view: "text", // Text input for date range
                            css: "reportrange",
                            value: moment().subtract(0, 'days').format('YYYY-MM-DD') + ' - ' + moment().format('YYYY-MM-DD'), // Default value for date range
                            label: "<span class='webix_icon icon-calendar'></span>" + _("Fecha"), // Label for the input
                            labelPosition: "top",
                            minWidth: 200,
                            placeholder: _("Click para seleccionar "), // Placeholder text
                        },
                        {
                            id: "Date", // Single date picker ID
                            name: "Date",
                            view: "datepicker", // Datepicker component
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _("Fecha"),
                            labelPosition: "top",
                            placeholder: _("Click para seleccionar "),
                            value: moment().format('YYYY-MM-DD'), // Default value for date
                            format: "%d %M %Y", // Date format
                            suggest: {
                                type: "calendar",
                                body: {
                                    maxDate: new Date() // Maximum selectable date
                                }
                            }
                        },
                        {
                            id: "id", // Player ID input
                            name: "id",
                            view: "text",
                            type: "number",
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _("ID jugador"),
                            labelPosition: "top",
                            placeholder: _("ID jugador"),
                        },
                        {
                            id: "playerName", // Player name input
                            name: "playerName",
                            view: "text",
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _("Nombre del Jugador"),
                            labelPosition: "top",
                            placeholder: _("Nombre"),
                        },
                        {
                            view: "richselect", // Dropdown for document type selection
                            name: "documentType",
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _("Tipo Documento"),
                            labelPosition: "top",
                            placeholder: _("Click para seleccionar "),
                            value: "0", // Default value
                            options: [
                                {"id": "C", "value": _("DNI")}, // DNI option
                                {"id": "E", "value": _("Cédula de extranjería")}, // Foreign ID option
                                {"id": "P", "value": _("Pasaporte")} // Passport option
                            ]
                        },
                    ]
                },
                {
                    responsive: "a1",
                    margin: 15,
                    css: "on-row",
                    cols: [
                        {
                            id: "documentNumber", // Document number input
                            name: "documentNumber",
                            view: "text",
                            type: "number",
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _("Numero del documento"),
                            labelPosition: "top",
                            placeholder: _("Numero"),
                        },
                        {
                            id: "jackpotId", // Jackpot ID input
                            name: "jackpotId",
                            view: "text",
                            type: "number",
                            minWidth: 200,
                            label: _("ID Jackpot"),
                            labelPosition: "top",
                            placeholder: _("ID Jackpot")
                        },
                        {
                            id: "gameName", // Game name input
                            name: "gameName",
                            view: "text",
                            minWidth: 200,
                            label: _("Nombre del Juego"),
                            labelPosition: "top",
                            placeholder: _("Nombre del Juego"),
                        },
                        {
                            view: "richselect", // Dropdown for jackpot type selection
                            name: "jackpotType",
                            minWidth: 200,
                            label: _("Tipo del Jackpot"),
                            labelPosition: "top",
                            placeholder: _("Click para seleccionar "),
                            value: "0", // Default value
                            options: [
                                {"id": 1, "value": _("Casino")}, // Casino option
                                {"id": 2, "value": _("LiveCasino")}, // Live Casino option
                                {"id": 3, "value": _("Virtuales")} // Virtual option
                            ]
                        },
                    ]
                },
            ]
        };
        const upper_section = {
            css: "father-container",
            rows: [{
                margin: 10,
                cols: [
                    left // Adding left section to the upper section
                ]
            }]
        };
        const buttons = {
            padding: 10,
            cols: [
                {},
                {
                    view: "button", // Clear button
                    value: _("Limpiar"),
                    width: (screen == "small") ? 0 : 100,
                    minWidth: 200,
                    margin:10,
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues()); // Reset form values
                        $$('Datepicker').setValue(""); // Clear datepicker value
                    }
                },
                {
                    id: "consultDesk", // Consult button
                    view: "button",
                    value: _("Consultar"),
                    hotkey: "enter",
                    type: "form",
                    width: (screen == "small") ? 0 : 100,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if condition is true
                            }
                        }
                        console.log(filterdata) // Log filter data
                        this.app.callEvent("gamesPerformance:filter", [filterdata]); // Trigger filter event
                        $$("b5").collapse(); // Collapse the accordion
                        $$('a5').scrollTo(100, 0); // Scroll to specific position
                    }
                }
            ]
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: "button", // Clear button for second form
                    value: _("Limpiar"),
                    click: () => {
                        $$('myForm2').setValues($$('myForm2').getCleanValues()); // Reset second form values
                        $$('Datepicker').setValue(""); // Clear datepicker value
                    }
                },
                {
                    id: "consultDesk", // Consult button for second form
                    view: "button",
                    value: _("Consultar"),
                    hotkey: "enter",
                    type: "form",
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get second form values
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if condition is true
                            }
                        }
                        this.app.callEvent("gamesPerformance:filter", [filterdata]); // Trigger filter event
                    }
                }
            ]
        };
        const accordion_section2 = {
            type: "wide",
            rows: [
                {
                    multi: true,
                    view: "accordion", // Accordion component for filters
                    css: "betShop",
                    collapsed: true,
                    type: "clean",
                    rows: [
                        {
                            id: "b5",
                            header: _("Filtros"), // Header for the accordion
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons] // Include upper section and buttons
                            }
                        }
                    ]
                }
            ]
        };
        const accordion_section3 = {
            view: "scrollview", // Scrollable view for filters
            scroll: "xy",
            body: {
                padding: 10,
                rows: [upper_section] // Include upper section
            }
        };
        const filterPopup = webix.ui({ // Popup window for filters
            view: "window",
            move: true,
            id: "filterPopup",
            fullscreen: true,
            modal: true,
            position: "center",
            head: {
                view: "toolbar",
                cols: [
                    {view: "label", label: _("Filtros"), align: "center"}, // Label for the popup
                    {
                        view: "icon", icon: "wxi-close", click: function () {
                            this.getTopParentView().hide(); // Close the popup
                        }
                    }
                ]
            },
            body: {
                view: "form", id: 'myForm2', // Form inside the popup
                type: "clean",
                rows: [
                    accordion_section3, buttons2 // Include accordion section and buttons
                ],
                rules: {
                    "fname": webix.rules.isNotEmpty // Validation rule for form
                }
            }
        });
        return {
            id: 'myForm', // Main form ID
            view: "form",
            type: "clean",
            rows: [
                (screen.width > 500 && screen.height > 500) ? accordion_section2 : {height: 1, width: 0} // Conditional rendering of accordion section
            ],
            rules: {
                "fname": webix.rules.isNotEmpty // Validation rule for form
            }
        };
    }
    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$("Date").hide(); // Hide Date input if typeDate is not 2
                $$("Datepicker").show(); // Show Datepicker
            } else {
                $$("Date").show(); // Show Date input
                $$("Datepicker").hide(); // Hide Datepicker
            }
        });
        const lang = this.app.getService("locale").getLang(); // Get current language
        $$('Datepicker').attachEvent("onAfterRender", function () {
            devConfig.setDateModal(lang); // Set date modal configuration based on language
        });
    }
}

// FILE DOCUMENTED
